import { AxiosPromise } from 'axios';
import { DetectionFilterCriteria } from 'Models/Videos/Detections/DetectionFilterCriteria';
import { getAxiosInstance } from 'Utils/Http/ApiManager';
import { ApiUrl, getApiUrl } from 'Utils/Http/ApiUrls';

export interface PostSeekNextVideoFrameDetectionRequest extends DetectionFilterCriteria {
	timestamp: number;
	backwards: boolean;
	seekBySecond: boolean;
}

const postSeekNextVideoFrameDetectionRequest = (
	token: string | null,
	videoId: number,
	request: PostSeekNextVideoFrameDetectionRequest
): AxiosPromise<number> => {
	const url = getApiUrl(ApiUrl.VideosVideoDetectionsSeek).replace(':videoId', videoId.toString());
	const axiosInstance = getAxiosInstance(token);
	return axiosInstance.post<number>(url, request);
};

export default postSeekNextVideoFrameDetectionRequest;
